const invalidate = ($context, fields) => {
    for (const property in fields) {
        let $field = $context.find(`[name=${property}]`);

        $field.addClass('is-invalid');

        const $divFeedback = $field.next("div.invalid-feedback");
        if ($divFeedback.length) {
            $divFeedback.html(fields[property].join("<br/>"));
        } else {
            if ($field.parent().hasClass('input-group')) {
                $field.parent().find(".invalid-feedback").remove();
                $field = $field.parent().find(":last");
            }
            $field.after(`<div class="invalid-feedback">${fields[property].join("<br/>")}</div>`);
        }
    }
}

const clearInvalidFeedback = ($context) => {
    $context.find(".invalid-feedback").remove();
    $context.find(".is-invalid").removeClass("is-invalid");
}

const updateCartQta = async (route, qta = null) => {
    const $qtaCart = $(".qta-cart");

    if (qta) $qtaCart.text(qta);
    else {
        const response = await $.ajax({
            method: 'GET',
            url: route
        });

        if (response.success) {
            $qtaCart.text(response.data.qta);

            return response.data;
        }
    }

    return null;
}

/**
 * KUOKKO
 */
const trovaConsegneCitta = (consegne_citta, lng, lat) => {
    let possibiliConsegneCitta = [];

    consegne_citta.forEach((consegnaCitta) => {
        if (consegnaCitta.tipo_coordinate === 'POLYGON') {
            let turfPolygon = turf.polygon([
                consegnaCitta.coordinate
                    .map((coordinata) => [coordinata.lng, coordinata.lat])
                    .concat([
                        [consegnaCitta.coordinate[0].lng, consegnaCitta.coordinate[0].lat],
                    ]),
            ]);

            if (turf.booleanPointInPolygon(turf.point([lng, lat]), turfPolygon)) {
                possibiliConsegneCitta.push({consegnaCitta, area: turf.area(turfPolygon)});
            }
        } else if (consegnaCitta.tipo_coordinate === 'CIRCLE') {
            let turfCircle = turf.circle(
                [
                    consegnaCitta.coordinate.center.lng,
                    consegnaCitta.coordinate.center.lat,
                ],
                consegnaCitta.coordinate.radius / 1000,
                {
                    steps: 10,
                    units: 'kilometers',
                },
            );
            if (turf.booleanPointInPolygon(point([lng, lat]), turfCircle)) {
                possibiliConsegneCitta.push({consegnaCitta, area: turf.area(turfCircle)});
            }
        }
    });

    return possibiliConsegneCitta;
}

const trovaConsegnaCitta = (consegne_citta, lng, lat) => {
    const possibiliConsegneCitta = trovaConsegneCitta(consegne_citta, lng, lat);

    if (possibiliConsegneCitta.length) {
        // La più piccola vince
        let winner = null;
        possibiliConsegneCitta.forEach((consegnaCitta) => {
            if (!winner) {
                winner = consegnaCitta;
            } else {
                if (consegnaCitta.area < winner.area) {
                    winner = consegnaCitta;
                }
            }
        });

        return winner.consegnaCitta;
    }

    return null;
}

const canAddProductInCombo = (category, picked, maxProd) => {
    if (maxProd) {
        const totalPicked = picked.reduce((accumulator, pick) => {
            return accumulator + pick.qta;
        }, 0);

        if (totalPicked >= maxProd) {
            return false;
        }
    }

    if (category.max_prod_selezionabili) {
        const totalPicked = picked.reduce((accumulator, pick) => {
            if (pick.id_categoria === category.id_categoria)
                return accumulator + pick.qta;
            else
                return accumulator;
        }, 0);

        if (totalPicked >= category.max_prod_selezionabili) {
            return false;
        }
    }

    return true;
}

const equalsInsensitive = (text1, text2) => {
    if (!text1) {
        return !text2;
    }

    if (!text2) {
        return false;
    }

    return text1.toLowerCase() === text2.toLowerCase();
}


export {
    invalidate,
    clearInvalidFeedback,
    updateCartQta,
    trovaConsegneCitta,
    trovaConsegnaCitta,
    canAddProductInCombo,
    equalsInsensitive
}
